module.exports = __webpack_public_path__ + "static/how-to-video-d8649bf6d34fe426983693976b0f2843.mp4";